// File: src/components/home/CarYugoBenefits.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/home/CarYugoBenefits.css";

const BUY_BENEFITS = [
  {
    id: "inspection",
    image: "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?w=400&q=80",
    icon: "🔍",
    title: "200-Point Inspection",
    desc: "Every car is carefully handpicked after a thorough quality inspection.",
  },
  {
    id: "warranty",
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=400&q=80",
    icon: "🛡️",
    title: "Warranty Included",
    desc: "Our way of being there for you through your car ownership journey.",
  },
  {
    id: "moneyback",
    // ✅ UPDATED: happy family receiving car keys — fits "5-Day Money Back" guarantee feel
    image: "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?w=400&q=80",
    icon: "5️⃣",
    title: "5-Day Money Back",
    desc: "All our cars come with a no-questions-asked 5-day money back guarantee.",
  },
  {
    id: "price",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&q=80",
    icon: "₹",
    title: "Fixed Price Assurance",
    desc: "No more endless negotiations or haggling. Get the best deal upfront.",
  },
];

const BRANDS = [
  { name: "Maruti Suzuki", abbr: "MS", color: "#003087" },
  { name: "Hyundai",       abbr: "HY", color: "#002C5F" },
  { name: "Tata",          abbr: "TA", color: "#00205C" },
  { name: "Honda",         abbr: "HO", color: "#CC0000" },
  { name: "Renault",       abbr: "RE", color: "#EFDF00" },
  { name: "Ford",          abbr: "FO", color: "#003478" },
  { name: "Volkswagen",    abbr: "VW", color: "#001E50" },
  { name: "Mahindra",      abbr: "MA", color: "#C4002B" },
  { name: "Kia",           abbr: "KI", color: "#05141F" },
  { name: "Audi",          abbr: "AU", color: "#BB0A30" },
  { name: "BMW",           abbr: "BM", color: "#1C69D4" },
  { name: "MORE",          abbr: "++", color: "#003566", isMore: true },
];

const SELL_IMAGE =
  "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=700&q=80";

const DEFAULT_SELL_CITY = "indore";

const CarYugoBenefits = () => {
  const [activeTab,     setActiveTab]     = useState("buy");
  const [selectedBrand, setSelectedBrand] = useState(null);
  const navigate = useNavigate();

  const handleBrandClick = (brand) => {
    if (brand.isMore) {
      navigate("/sell-car");
      return;
    }
    setSelectedBrand(brand.name);
    navigate(`/sell-car/${DEFAULT_SELL_CITY}/journey`, {
      state: {
        prefill:   { car_brand: brand.name },
        startStep: 3,
      },
    });
  };

  return (
    <section className="cyb-section">
      <div className="cyb-card">

        <div className="cyb-tabs">
          <button
            className={`cyb-tab ${activeTab === "buy" ? "active" : ""}`}
            onClick={() => setActiveTab("buy")}
          >
            Buy car
          </button>
          <button
            className={`cyb-tab ${activeTab === "sell" ? "active" : ""}`}
            onClick={() => setActiveTab("sell")}
          >
            Sell car
          </button>
        </div>

        {activeTab === "buy" && (
          <div className="cyb-buy-content">
            <h2 className="cyb-heading">CarYugo benefits</h2>

            <div className="cyb-benefits-grid">
              {BUY_BENEFITS.map((b) => (
                <div className="cyb-benefit-card" key={b.id}>
                  <div className="cyb-benefit-img-wrap">
                    <img
                      src={b.image}
                      alt={b.title}
                      className="cyb-benefit-img"
                      onError={(e) => {
                        e.currentTarget.style.opacity = "0";
                      }}
                    />
                    <span className="cyb-benefit-badge">{b.icon}</span>
                  </div>
                  <h3 className="cyb-benefit-title">{b.title}</h3>
                  <p className="cyb-benefit-desc">{b.desc}</p>
                </div>
              ))}
            </div>

            <div className="cyb-buy-footer">
              <button className="cyb-link-btn" onClick={() => navigate("/how-it-works")}>
                ▶ Watch how it works
              </button>
              <button className="cyb-primary-btn" onClick={() => navigate("/buy-cars")}>
                Browse cars
              </button>
              <button className="cyb-link-btn" onClick={() => navigate("/about")}>
                Learn more &rsaquo;
              </button>
            </div>
          </div>
        )}

        {activeTab === "sell" && (
          <div className="cyb-sell-content">

            <div className="cyb-sell-left">
              <img src={SELL_IMAGE} alt="Sell your car" className="cyb-sell-img" />
              <div className="cyb-sell-img-overlay">
                <p className="cyb-sell-tagline">
                  Sell your car for the<br />
                  <strong>best price</strong>
                </p>
              </div>
            </div>

            <div className="cyb-sell-right">
              <h2 className="cyb-heading">Select your car brand to get started</h2>

              <div className="cyb-sell-badges">
                <span className="cyb-badge">⚡ Instant online quote</span>
                <span className="cyb-badge">🖥️ Free car evaluation</span>
                <span className="cyb-badge">💰 Same day payment</span>
              </div>

              <div className="cyb-brand-grid">
                {BRANDS.map((brand) => (
                  <button
                    key={brand.name}
                    className={`cyb-brand-btn ${selectedBrand === brand.name ? "selected" : ""} ${brand.isMore ? "more" : ""}`}
                    onClick={() => handleBrandClick(brand)}
                    title={brand.isMore ? "View all brands" : `Sell my ${brand.name}`}
                  >
                    <span className="cyb-brand-logo" style={{ background: brand.color }}>
                      {brand.abbr}
                    </span>
                    <span className="cyb-brand-name">{brand.name}</span>
                  </button>
                ))}
              </div>

              <div className="cyb-sell-footer">
                <button className="cyb-primary-btn sell" onClick={() => navigate("/sell-car")}>
                  Get price
                </button>
                <span className="cyb-sellright">
                  <span className="cyb-sellright-icon">$</span>
                  <strong>Sell</strong>Right
                </span>
              </div>
            </div>

          </div>
        )}

      </div>
    </section>
  );
};

export default CarYugoBenefits;